<template>
<div class="col-12 border-primary border-solid border-round-sm border-2">
<div class="grid">
<div class="col-12"><h4 class="text-pink-500 my-0 ">Koşullar</h4></div>

<LogicBundleConditionLine 
v-for="condition in bundle.conditions"
:thecondition="condition"
:inputs="inputs"
@conditionUpdated="conditionUpdated"
@removeCondition="removeCondition"
:key="condition.id"
/>

<template v-if="bundle.outcome">
<div class="col-12"><h4 class="text-pink-500 my-0 ">Çıktı</h4></div>

<LogicBundleOutcomeLine 
:theoutcome="bundle.outcome"
:inputs="inputs"
@outcomeUpdated="outcomeUpdated"
/>	
</template>

</div>
</div>
</template>

<script>
const conditionmodel = {
		id:null,
	    type:null,//inputfield,customattribute
	    comparison_type:null,
	    selected_input:null,
	    comparison_input:null,
	    text_val:null,
	    numerical_val:null,
	    execution_type:null,
	    operator:null,
		}
const outcomemodel = {
	id:null,
	text_val:null,
	numerical_val:null,
	operator:null,
	comparison_type:null,
	output_type:null,//numerical,textual
}
import LogicBundleConditionLine from "./LogicBundleConditionLine"
import LogicBundleOutcomeLine from "./LogicBundleOutcomeLine"
export default {

  name: 'LogicBundle',
  props:["bundle","inputs"],
  data () {
    return {	

    }
  },
  components:{LogicBundleConditionLine,LogicBundleOutcomeLine},
  methods:{
  	outcomeUpdated(data)
  	{

  	},
  	conditionUpdated(data)
    {
    	let selectednode = this.$store.state.calculations.selectednode
        let bundle_ind = selectednode.data.logic_bundles.findIndex(item=>item.id == this.bundle.id)
        let last_condition = selectednode.data.logic_bundles[bundle_ind].conditions[selectednode.data.logic_bundles[bundle_ind].conditions.length-1]

      if(data.condition.operator=="execute")
      {
      	this.addOutcome()
      }
      if(data.condition.operator=="and" || data.condition.operator=="or")
      {
        

        if(!last_condition.id && !last_condition.comparison_type && !last_condition.execution_type && !last_condition.operator)
        {

        }
        else
        {
        	if(last_condition.operator!=="execute")
        	{
        		this.addCondition()
        	}
          
        }
        
      }
    },
    addOutcome()
    {
    	let selectednode = this.$store.state.calculations.selectednode
  		let bundle_ind = selectednode.data.logic_bundles.findIndex(item=>item.id == this.bundle.id)
  		if(!selectednode.data.logic_bundles.outcome)
  		{
  			let outcome = this.sanitizeArray(outcomemodel)
	  		outcome.id = this.generateId()
	  		selectednode.data.logic_bundles[bundle_ind].outcome = outcome
	  		this.updateNodeData(selectednode)
  		}
  		
    },
    removeCondition(id)
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		let bundle_ind = selectednode.data.logic_bundles.findIndex(item=>item.id == this.bundle.id)
  		let bundle = selectednode.data.logic_bundles[bundle_ind]
  		bundle.conditions = bundle.conditions.filter(item=>item.id !==id) 
  		selectednode.data.logic_bundles[bundle_ind] = bundle 
  		this.updateNodeData(selectednode)
  		if(!bundle.conditions.length)
  		{

  			this.addCondition()
  		}
  	},
  	addCondition()
  	{  		
  		let selectednode = this.$store.state.calculations.selectednode
  		let bundle_ind = selectednode.data.logic_bundles.findIndex(item=>item.id == this.bundle.id)
  		let condition = this.sanitizeArray(conditionmodel)
  		condition.id = this.generateId()
  		selectednode.data.logic_bundles[bundle_ind].conditions.push(condition)
  		this.updateNodeData(selectednode)
  	},
  	updateNodeData(selectednode)
  	{
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == selectednode.id})
  		nodes[ind] = selectednode
  		this.$store.dispatch('calculations/setNodes',nodes)
      	this.$store.dispatch('calculations/setSelectedNode',selectednode)
  	},

  }
}
</script>

<style lang="css" scoped>
</style>